import { useCallback, useEffect, useRef } from 'react';

export enum ScrollDirection {
  UP,
  DOWN,
}

export const useScrollDirection = (
  handleScrollEvent: (scrollDirection: ScrollDirection | null) => void,
) => {
  const prevOffset = useRef(0);
  const callbackHandleScrollEvent = useCallback(
    (_: Event) => {
      const scrollY = window.scrollY;
      let direction: ScrollDirection | null = null;
      if (scrollY === 0) {
        direction = null;
      } else if (scrollY > prevOffset.current) {
        direction = ScrollDirection.DOWN;
      } else if (scrollY < prevOffset.current) {
        direction = ScrollDirection.UP;
      }
      handleScrollEvent(direction);
      prevOffset.current = scrollY;
    },
    [handleScrollEvent],
  );
  useEffect(() => {
    const onScroll = (e: Event) => {
      callbackHandleScrollEvent(e);
    };
    window.addEventListener('scroll', onScroll);
    return () => {
      window.removeEventListener('scroll', onScroll);
    };
  }, [callbackHandleScrollEvent]);
};
